import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  AddressForm,
  Button,
  Col,
  Dropdown,
  Menu,
  MenuItem,
  Modal,
  Row,
  Table
} from '../../../../core/components'
import { AddressWithId, Pagination } from '../../../../entities'
import useCustomerAddressCreate from '../../../../services/mutations/useCustomerAddressCreate'
import useCustomerAddressDelete from '../../../../services/mutations/useCustomerAddressDelete'
import useCustomerAddressUpdate from '../../../../services/mutations/useCustomerAddressUpdate'
import useCustomerAddresses from '../../../../services/queries/customer/useCustomerAddresses'
import { zipCodeFormat } from '../../../../utils/format/zipCodeFormat'

const addressDefaultValues = {
  id: '',
  type: '',
  address: '',
  number: '',
  district: '',
  complement: '',
  zipCode: '',
  city: '',
  state: ''
}

export const AddressTab = () => {
  const { id }: any = useParams()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isEditModalVisible, setIsEditModalVisible] = useState(false)
  const [formState, setFormState] = useState({ isError: false })
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const [form, setForm] = useState<AddressWithId>(addressDefaultValues)

  const { data, error, isLoading }: any = useCustomerAddresses({
    ...pagination,
    id
  })

  const { mutate: updateAddress } = useCustomerAddressUpdate()
  const { mutate: saveAddress } = useCustomerAddressCreate()
  const { mutate: deleteAddress } = useCustomerAddressDelete()

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const showModal = () => {
    setIsModalVisible(true)
  }

  const showEditModal = () => {
    setIsEditModalVisible(true)
  }
  const handleEdit = (row: any) => {
    setForm(row)
    showEditModal()
  }

  const handleOk = () => {
    saveAddress({
      ...form,
      zipCode: Number(String(form.zipCode).replace(/\D/g, '')),
      id
    })
    setForm(addressDefaultValues)
    setIsModalVisible(false)
  }

  const handleEditOk = () => {
    updateAddress({
      ...form,
      zipCode: Number(String(form.zipCode).replace(/\D/g, '')),
      id
    })
    setForm(addressDefaultValues)
    setIsEditModalVisible(false)
  }

  const handleDelete = (row: any) => {
    deleteAddress({ sequence: row.sequence, id })
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }
  const handleEditCancel = () => {
    setIsEditModalVisible(false)
  }

  const ActionMenu = ({ row }: any) => {
    return (
      <Row gutter={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <Col>
          <Dropdown
            overlay={
              <Menu>
                <MenuItem
                  onClick={() => handleEdit(row)}
                  key="1"
                  icon={<EditOutlined style={{ color: '#1890ff' }} />}
                >
                  Editar
                </MenuItem>
                {row.type !== 'PRINCIPAL' && (
                  <MenuItem
                    onClick={() => handleDelete(row)}
                    key="3"
                    icon={<DeleteOutlined style={{ color: '#f5222d' }} />}
                  >
                    Excluir
                  </MenuItem>
                )}
              </Menu>
            }
          >
            <Button>
              <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
      </Row>
    )
  }

  const columns = useMemo(
    () => [
      {
        title: 'Cidade',
        dataIndex: 'city',
        key: 'city'
      },
      {
        title: 'Estado',
        dataIndex: 'state',
        key: 'state'
      },
      {
        title: 'Endereço',
        dataIndex: 'address',
        key: 'address'
      },
      {
        title: 'Número',
        dataIndex: 'number',
        key: 'number'
      },
      {
        title: 'Bairro',
        dataIndex: 'district',
        key: 'district'
      },
      {
        title: 'Tipo',
        dataIndex: 'type',
        key: 'type'
      },
      {
        title: 'CEP',
        dataIndex: 'zipCode',
        key: 'zipCode',
        render: (value: any) => (value ? zipCodeFormat(String(value)) : '')
      },
      {
        title: 'Ações',
        dataIndex: '#',
        key: 'action',
        // eslint-disable-next-line react/display-name
        render: (_: any, obj: any) => <ActionMenu row={obj} />
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <>
      <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
        Novo
      </Button>
      <Modal
        title="Novo Endereço"
        visible={isModalVisible}
        onCancel={handleCancel}
        okText="Cadastrar"
        cancelText="Cancelar"
        centered
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button
            disabled={formState.isError}
            key="submit"
            type="primary"
            onClick={handleOk}
          >
            Cadastrar
          </Button>
        ]}
      >
        <AddressForm
          value={form}
          setValue={setForm}
          setFormState={setFormState}
        />
      </Modal>
      <Modal
        title="Editar Endereço"
        visible={isEditModalVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        okText="Atualizar"
        cancelText="Cancelar"
        centered
      >
        <AddressForm
          value={form}
          setValue={setForm}
          setFormState={setFormState}
        />
      </Modal>
      <div style={{ height: 10 }} />
      <Table
        columns={columns}
        dataSource={data.data}
        bordered
        pagination={{
          pageSize: pagination.limit,
          current: pagination.page,
          total: data?.total,
          onChange: (page, limit) => handlePagination(page, limit || 10)
        }}
      />
    </>
  )
}
